import { computed, Ref, unref } from 'vue'

export function useMarketDependentValue<T>(
  market: Ref<string | null> | string | null,
  marketValues: Record<string, T>,
  defaultValue: T,
): { marketValue: Ref<T> } {
  const marketUnref = unref(market)

  const marketValue = computed((): T => {
    if (marketUnref === null) {
      return defaultValue
    }
    if (!marketValues.hasOwnProperty(marketUnref)) {
      return defaultValue
    }
    return marketValues[marketUnref]
  })

  return { marketValue }
}
